"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6871],{

/***/ 36871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_atoms_box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33369);
/* harmony import */ var _opendoor_atoms_button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(57306);
/* harmony import */ var _opendoor_atoms_text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63080);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23515);
/* harmony import */ var _helpers_queryParams__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17706);







var MaintenanceBanner = function() {
    var maintenance_start_time_local = (0,_helpers_queryParams__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().maintenance_start_time_local;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(maintenance_start_time_local !== undefined), showBanner = ref[0], setShowBanner = ref[1];
    var closeBanner = function() {
        return setShowBanner(false);
    };
    if (!showBanner) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_atoms_box__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X2, {
        className: "justify-between bg-od-bg-error-secondary px-6 py-4",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_atoms_text__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                as: "p",
                className: "grow text-center text-body-md font-medium md:text-body-lg",
                children: [
                    "Opendoor will be down for scheduled maintenance on ",
                    maintenance_start_time_local
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_atoms_button__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                "aria-label": "Close banner",
                size: "sm",
                variant: "secondary",
                onClick: closeBanner,
                id: "maintenance-banner-close-button",
                analyticsName: "cosmos-maintenance-banner-close",
                className: "h-8 w-8 self-center rounded-full border-transparent bg-transparent p-0 hover:border-transparent hover:bg-transparent active:bg-transparent",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    size: 20,
                    "aria-hidden": "true"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (MaintenanceBanner);


/***/ })

}]);